import { render, staticRenderFns } from "./Listitems.vue?vue&type=template&id=096b67e9&scoped=true&"
import script from "./Listitems.vue?vue&type=script&lang=js&"
export * from "./Listitems.vue?vue&type=script&lang=js&"
import style0 from "./Listitems.vue?vue&type=style&index=0&id=096b67e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b67e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VOverlay,VProgressCircular,VRow,VSimpleTable})
